import { IconButton, TextInput } from '@unmind/design-system-components-web';
import { Arrow } from 'icons';
import { rem } from 'polished';
import { css, styled } from 'styles';
import { MIN_HEIGHT_CHAT_INPUT_HOMEPAGE } from '../styles';

export const ChatBotTextInput = styled(TextInput)<{
  $displayOnHomepage: boolean;
}>`
  max-height: ${rem(144)};
  padding: ${rem(4)} ${rem(4)};
  margin-left: ${rem(8)};

  ${({ $displayOnHomepage }) =>
    $displayOnHomepage &&
    css`
      min-height: ${MIN_HEIGHT_CHAT_INPUT_HOMEPAGE};
    `}
`;

export const InputButton = styled(IconButton)<{ $displayOnHomepage: boolean }>`
  ${({ $displayOnHomepage }) =>
    $displayOnHomepage &&
    css`
      align-self: flex-end;
    `}

  border: none;
`;

export const ArrowIcon = styled(Arrow)`
  rotate: -90deg;
`;
